window.addressForm = {}

window.addressForm.checkAdres = () => {

    var land = document.querySelector('#land').value

    if (land == 13) {

        document.querySelector('#straat-element').style.display = 'inherit'
        document.querySelector('#nummer-element').style.display = 'inherit'
        document.querySelector('#toevoegsel-element').style.display = 'inherit'
        document.querySelector('#postcode-element').style.display = 'inherit'
        document.querySelector('#plaats-element').style.display = 'inherit'

        document.querySelector('#adres-element').style.display = 'none'
        document.querySelector('#land-element').classList.remove('w-full')
        document.querySelector('#land-element > select').classList.remove('w-full')

        window.addressForm.loadAdres(true)

    } else {

        document.querySelector('#straat-element').style.display = 'none'
        document.querySelector('#nummer-element').style.display = 'none'
        document.querySelector('#toevoegsel-element').style.display = 'none'
        document.querySelector('#postcode-element').style.display = 'none'
        document.querySelector('#plaats-element').style.display = 'none'

        document.querySelector('#adres-element').style.display = 'inherit'
        document.querySelector('#land-element').classList.add('w-full')
        document.querySelector('#land-element > select').classList.add('w-full')
    }
}

window.addressForm.loadAdres = (check) => {

    var postcode = document.querySelector('#postcode').value
    var nummer = document.querySelector('#nummer').value

    while (postcode.match(/[-]/)) {
        postcode = postcode.replace(/[-]/, '')
    }

    while (postcode.match(/[\s]/)) {
        postcode = postcode.replace(/[\s]/, '')
    }

    postcode = postcode.toUpperCase()

    nummer = parseInt(nummer, 10)

    if (postcode.match(/^[1-9][0-9]{3}[A-Za-z]{2}$/i) && nummer > 0) {

        axios({
			method: "get",
			url: window.location.origin+'/regicrm/form/zoekadres',
			params: {
                'postcode': postcode,
                'nummer': nummer
            },
		})
		.then(({ data }) => {
            if (data != null && data.length != 0) {

                if (!check) {

                    document.querySelector('#straat').value = data.straat
                    document.querySelector('#nummer').value = data.nummer
                    document.querySelector('#postcode').value = data.postcode
                    document.querySelector('#plaats').value = data.plaats
                }

                document.querySelector('#straat').setAttribute('readonly', 'readonly')
                document.querySelector('#plaats').setAttribute('readonly', 'readonly')

            } else {

                document.querySelector('#straat').removeAttribute('readonly')
                document.querySelector('#plaats').removeAttribute('readonly')

                if (!check) {

                    document.querySelector('#straat').value = ''
                    document.querySelector('#nummer').value = nummer
                    document.querySelector('#postcode').value = postcode.substring(0, 4) + ' ' + postcode.substring(4, 6)
                    document.querySelector('#plaats').value = ''

                    alert('De combinatie van nummer en postcode is niet gevonden. Voer het adres handmatig in.')
                }
            }
		})

    } else {

        if (!check) {
            document.querySelector('#straat').value = ''
            document.querySelector('#plaats').value = ''
        }

        document.querySelector('#straat').setAttribute('readonly', 'readonly')
        document.querySelector('#plaats').setAttribute('readonly', 'readonly')
    }
}

window.addressForm.focusAdres = () => {

    var postcode = document.querySelector('#postcode').value
    var nummer = document.querySelector('#nummer').value

    while (postcode.match(/[-]/)) {
        postcode = postcode.replace(/[-]/, '')
    }

    while (postcode.match(/[\s]/)) {
        postcode = postcode.replace(/[\s]/, '')
    }

    postcode = postcode.toUpperCase()

    nummer = parseInt(nummer, 10)

    if (!postcode.match(/^[1-9][0-9]{3}[A-Za-z]{2}$/i)) {
        document.querySelector('#postcode').focus()
    } else if (isNaN(nummer) || nummer == 0) {
        document.querySelector('#nummer').focus()
    }
}